import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import CreateSoundButton from './CreateSoundButton';

import Sound from '../../../../../../../domain/entities/Sound';

interface Props {
  storyId: number;
  onSelectSound: (sound: Sound) => void;
}

const BottomCreateSoundButton: React.FunctionComponent<Props> = props => {
  return (
    <View style={styles.container}>
      <CreateSoundButton {...props} />
    </View>
  );
};

export default React.memo(BottomCreateSoundButton);

const styles = StyleSheet.create({
  container: {
    left: 0,
    right: 0,
    position: 'absolute',
    bottom: 0,
    paddingBottom: 16,
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  } as ViewStyle,
});
